const EMAIL_REGEX = new RegExp(/^[\w-.+]+@([\w-]+\.)+[\w-]{2,63}$/);
export const isValidEmail = (input: string): boolean => EMAIL_REGEX.test(input);
